import { FileText, CalendarCheck, CheckCircle } from "lucide-react";

const HowItWorksSection = () => {
  const steps = [
    {
      number: 1,
      icon: FileText,
      title: "Request a Quote",
      description:
        "Fill out our simple form with your cleaning needs and home details. We'll provide a transparent estimate.",
    },
    {
      number: 2,
      icon: CalendarCheck,
      title: "Schedule Cleaning Appointment",
      description:
        "Choose a date and time that works for your schedule. We offer flexible booking options.",
    },
    {
      number: 3,
      icon: CheckCircle,
      title: "Professional Cleaning Service",
      description:
        "Our experienced team arrives on time and delivers thorough, high-quality cleaning.",
    },
  ];

  return (
    <section
      id="how-it-works"
      className="section-padding bg-white"
      data-testid="how-it-works-section"
    >
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-sky-100 text-sky-700 rounded-full text-sm font-medium mb-4">
            Simple Process
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            How It Works
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Getting your home cleaned is easy with our streamlined booking process
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12" data-testid="steps-grid">
          {steps.map((step, index) => (
            <div
              key={index}
              className="step-card relative"
              data-testid={`step-${step.number}`}
            >
              {/* Connector Line (hidden on mobile, visible on md+) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 bg-sky-100 -z-10" />
              )}
              
              {/* Step Number */}
              <div className="step-number">
                {step.number}
              </div>
              
              {/* Icon */}
              <div className="w-16 h-16 rounded-2xl bg-sky-50 flex items-center justify-center mx-auto mb-6">
                <step.icon className="w-8 h-8 text-sky-600" />
              </div>
              
              {/* Content */}
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 bg-gradient-to-r from-sky-50 to-sky-100/50 rounded-2xl p-8 md:p-12 text-center">
          <h3 className="text-2xl font-bold text-slate-900 mb-4">
            Scheduling Made Convenient
          </h3>
          <p className="text-slate-600 max-w-2xl mx-auto mb-2">
            We understand your time is valuable. That's why we offer flexible scheduling 
            options and clear communication throughout the process. Our team will confirm 
            your appointment and keep you informed every step of the way.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
